import { UserModel, UserStateModel } from './model';

export const getUser = (state: UserStateModel): UserModel => {
  console.log(state);
  return state.userModel;
};
